import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared';
import { IPaginationParams } from '../interfaces/IPaginationParamas';
import { IBusiness } from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class BusinessService {
  constructor(private http: HttpClient) {}

  getAllBusiness(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/business', { params });
  }

  getBusinessById(id: string) {
    return this.http.get<ApiResponse>(`/v1/admin/business/${id}`);
  }

  deleteBusiness(id: string) {
    return this.http.delete<ApiResponse>(`/v1/admin/business/${id}`);
  }

  addBusiness(business: IBusiness) {
    return this.http.post('v1/admin/business', business);
  }

  updateBusiness(id: string, business: any) {
    return this.http.put<ApiResponse>(`v1/admin/business/${id}`, business);
  }

  getAllWorkArea() {
    const param = new HttpParams();
    param.set('pageLimit', 1000);
    return this.http.get<ApiResponse>('/v1/admin/work-areas', { params: param });
  }

  exportBusinessContent(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '')
      .set('userId', filterData.userId ? filterData.userId : '')
      .set('showFavourite', filterData.showFavourite ? filterData.showFavourite : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/business/export`, filterData, options);
  }
}
